// src/app/core/auth/auth.interceptor.ts
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';

export const authInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);

  const token = authService.accessToken;
  const authReq = token
    ? req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) })
    : req;

  return next(authReq).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        // authService.signOut(); // TODO: Validar se o sistema deve realmente deslogar usuário em caso de não autorizado
      }
      return throwError(() => error);
    })
  );
};
